export default "__VITE_ASSET__DDwLlHYh__"